import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "row",
  id: "visit-request"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "row mx-2 my-5" }
const _hoisted_5 = { class: "col-sm-12 col-md-4 order-md-last" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "col-sm-12 col-md-8" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-12 card" }
const _hoisted_10 = { class: "text-center mt-5" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "h2" }
const _hoisted_13 = { class: "applicant-contact mb-0 w-50 m-auto" }
const _hoisted_14 = { class: "mx-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", null, "An interview has been requested by " + _toDisplayString(_ctx.interviewRequest.trainer.name) + ".", 1),
                _cache[7] || (_cache[7] = _createElementVNode("p", null, "Please review the below dates and approve a selection that is convienent for you.", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("p", null, "If you are not available on either date, please reject this request and a new set will be sent to you.", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interviewRequest.dates, (date) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: date.id,
                    class: "d-block"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "request_date_id",
                      value: date.id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.request_date_id.value) = $event))
                    }, null, 8, _hoisted_6), [
                      [_vModelRadio, _ctx.form.request_date_id.value]
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.moment(date.local_time).format('MM/DD/YY h:mm a')), 1)
                  ]))
                }), 128)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-secondary w-100 mb-2",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showApproveModal && _ctx.showApproveModal(...args)))
                }, "Accept"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-secondary w-100 mb-2",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showRejectModal && _ctx.showRejectModal(...args)))
                }, "Reject")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        class: "rounded-circle",
                        width: "100",
                        src: _ctx.interviewRequest.trainer.image
                      }, null, 8, _hoisted_11),
                      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.interviewRequest.trainer.name), 1),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.interviewRequest.trainer.email), 1),
                      _cache[9] || (_cache[9] = _createElementVNode("p", { class: "applicant-contact mb-5 w-50 m-auto" }, "Trainer", -1)),
                      _cache[10] || (_cache[10] = _createElementVNode("hr", { class: "hr-dark" }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[11] || (_cache[11] = _createElementVNode("h4", null, "Experience", -1)),
                      _createElementVNode("p", null, _toDisplayString(_ctx.interviewRequest.trainer.experience), 1),
                      _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_modal, {
      modelValue: _ctx.approveModal,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.approveModal) = $event))
    }, {
      header: _withCtx(() => _cache[13] || (_cache[13] = [
        _createTextVNode("Approve Interview Request")
      ])),
      default: _withCtx(() => [
        _cache[14] || (_cache[14] = _createElementVNode("p", null, "Are you sure you want to approve this request?", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-xs float-end",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.approveRequest && _ctx.approveRequest(...args)))
        }, "Approve Interview Request")
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_modal, {
      modelValue: _ctx.rejectModal,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rejectModal) = $event))
    }, {
      header: _withCtx(() => _cache[15] || (_cache[15] = [
        _createTextVNode("Reject Interview Request")
      ])),
      default: _withCtx(() => [
        _cache[16] || (_cache[16] = _createElementVNode("p", null, "Are you sure you want to reject this request?", -1)),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-xs float-end",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.rejectRequest && _ctx.rejectRequest(...args)))
        }, "Reject Interview Request")
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}